import * as Yup from "yup";
import { FormikProvider, useFormik } from "formik";
import SelectFormik from "@/common/components/form/SelectFormik";
import { FileInputPdf } from "@/common/components/form/FileInputPdf";
import ButtonWithLoader from "@/common/components/ui/loading/ButtonLoading";
import { CrlvFormValues } from "../Modals/ModalCrlv";

const validationSchema = Yup.object().shape({
  year: Yup.string().required("O ano é obrigatório"),
  crlv: Yup.string().required("O arquivo CRLV é obrigatório"),
});

type FormPropsCrlv = {
  onSubmit: (values: CrlvFormValues) => Promise<unknown>; // Ajustado para o handleSaveCrlv
  pathToUpload: string;
  formRequestErrors?: { message: string; path: string[] }[];
};

// Função para gerar a lista de anos (CORRIGIDA)
const generateYearOptions = () => {
  const currentYear = new Date().getFullYear();
  const years: string[] = []; // <-- CORREÇÃO AQUI // Gera os últimos 10 anos + o ano atual
  for (let i = 0; i <= 10; i++) {
    const year = currentYear - i;
    years.push(String(year)); // <-- CORREÇÃO AQUI
  }
  return years;
};

export default function FormCrlv(props: FormPropsCrlv) {
  const yearOptions = generateYearOptions();
  const currentYear = new Date().getFullYear().toString();

  const formik = useFormik({
    initialValues: {
      year: currentYear, // Define o ano atual como padrão
      crlv: "",
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      await props.onSubmit(values);
      setSubmitting(false);
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <FormikProvider value={formik}>
        <section className="mb-3">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <SelectFormik
              label="Ano do Documento:"
              name="year"
              required={true}
              options={yearOptions} // Agora 'yearOptions' é string[] e é compatível
            />
          </div>
          <div className="mt-4">
            <h3 className="font-bold ml-2">Arquivo CRLV</h3>
            <FileInputPdf
              onChange={(path) => formik.setFieldValue("crlv", path)}
              pathToUpload={props.pathToUpload}
              currentPath={formik.values.crlv} // Mostra o path do arquivo recém-enviado
              nameFile="Enviar CRLV"
            />
            {formik.errors.crlv && formik.touched.crlv && (
              <div className="text-red-500 text-sm mt-1">
                {formik.errors.crlv}
              </div>
            )}
          </div>
        </section>
        <div className="flex justify-end mt-6">
          <ButtonWithLoader
            isLoading={formik.isSubmitting}
            type="submit" // Garante que o formik.handleSubmit é chamado
          >
            Salvar CRLV
          </ButtonWithLoader>
        </div>
      </FormikProvider>
    </form>
  );
}
